import { render, staticRenderFns } from "./img-upload.vue?vue&type=template&id=a8d839f0&scoped=true"
import script from "./img-upload.vue?vue&type=script&lang=js"
export * from "./img-upload.vue?vue&type=script&lang=js"
import style0 from "./img-upload.vue?vue&type=style&index=0&id=a8d839f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d839f0",
  null
  
)

export default component.exports